export default function Lock(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="6.75" y="12.0195" width="18.5" height="12.7308" rx="1.01923" stroke="white" strokeWidth="1.5" />
            <path
                d="M10.5 11.2692V11.1757C10.5 8.04109 13.0411 5.5 16.1757 5.5V5.5C19.3103 5.5 21.8513 8.04109 21.8513 11.1757V11.2692"
                stroke="white"
                strokeWidth="1.5"
            />
            <circle cx="16" cy="17.3652" r="1.5" stroke="white" strokeWidth="1.5" />
            <path
                d="M15.25 22.1541C15.25 22.5683 15.5858 22.9041 16 22.9041C16.4142 22.9041 16.75 22.5683 16.75 22.1541H15.25ZM15.25 19.0771V22.1541H16.75V19.0771H15.25Z"
                fill="white"
            />
        </svg>
    );
}
